import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { TableExtendedService } from './table.extended.service';
import { Utility } from '../utils/utility';
import { Subject } from '@microsoft/signalr';

@Injectable({
  providedIn: 'root',
})
export class TenantService extends TableExtendedService {
  tenant$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(http: HttpClient) {
    super(http);
    this.setApiUrl(`${environment.apiUrl}/tenant`);
    this.getCurrentByUrl().subscribe();
  }

  getForSuperAdmin(filter: any):Observable<any> {
    let params = Utility.tableStateToHttpParams(filter);

    return this.http.get(`${environment.apiUrl}/Tenant/admin`, { params: params })
  }

  getCurrentByUrl() {
    return this.http
      .get(`${environment.apiUrl}/Tenant/current`,)
      .pipe(
        tap((x) => {
          localStorage.setItem('tenant', JSON.stringify(x));
          this.tenant$.next(x);
        })
      );
  }

  getAuthorizedTenant() {
    let params = new HttpParams();
    return this.http
      .get(`${environment.apiUrl}/Tenant/GetAuthorizedTenantByUser`, {
        params: params,
      })
      .pipe(
        tap((x) => {
          localStorage.setItem('tenants', JSON.stringify(x));
        })
      );
  }

  getForEdit(id: string) {
    return this.http.get(`${environment.apiUrl}/Tenant/admin/edit/${id}`)
  }

  getStats() {
    return this.http.get(`${environment.apiUrl}/Tenant/admin/stats`)
  }

  rename(tenantId: number, tenantName: string) {
    return this.http.put(`${environment.apiUrl}/Tenant/Rename/`, {
      tenantId,
      tenantName,
    }); //.pipe(throwError);
  }

  exit(tenantId: number): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/Tenant/Exit/${tenantId}`);
  }

  requestInvoice(tenantId: any, paymentId: any) {
    return this.http.post(`${environment.apiUrl}/Tenant/requestInvoice`, {
      tenantId,
      paymentId,
    });
  }

  getLogo(tenantId: number): Observable<string> {
    return this.http.get<string>(`${environment.apiUrl}/Tenant/GetLogo/${tenantId}`);
  }

  add(value: any) {
    let formData = Utility.objectToFormData(value);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };
    return this.http.post(`${environment.apiUrl}/Tenant`, formData, options)
  }

  override update(value: any) {
    let formData = Utility.objectToFormData(value);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };
    return this.http.put(`${environment.apiUrl}/Tenant`, formData, options)
  }

  deactivate(id: any) {
    return this.http.put(`${environment.apiUrl}/Tenant/deactivate/${id}`, {})
  }

  activate(id: any) {
    return this.http.put(`${environment.apiUrl}/Tenant/activate/${id}`, {})
  }

}
